/**
 * useCurrency — the single hook every price-rendering component uses.
 *
 * The store is USD-only: every stored cent is a USD cent and every order is
 * charged in USD. This hook simply formats those cents for display.
 *
 *   const { fmt } = useCurrency();
 *
 * The `opts.usd` flag (used by the admin/back-office call sites) is retained as
 * a harmless no-op, and `currency` / `setCurrency` / `toggleCurrency` are kept
 * on the returned object so existing consumers keep working unchanged.
 */
import { formatPrice } from '../utils/helpers';

export function useCurrency() {
  return {
    currency: 'USD',
    effectiveCurrency: 'USD',
    rate: null,
    fxFetchedAt: null,
    fmt: (cents) => formatPrice(cents),
    setCurrency: () => {},
    toggleCurrency: () => {},
  };
}
